<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-11-03 13:43:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-17 16:05:11
-->
<template>
  <v-menu offset-y
          :disabled="readonly"
          max-width="290px"
          min-width="290px"
          transition="scale-transition"
          :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <div style="position:relative;"
           class="box"
           :class="{csbox:Boolean(value)}"
           v-on="on">
        <v-combobox :label="label||$t('label_color')"
                    :placeholder="label||$t('label_color')"
                    :clearable="!readonly"
                    ref="colorcombox"
                    @click:clear="clickClear"
                    height="40"
                    :append-icon="readonly ? '' : 'arrow_drop_down'"
                    :value="value"
                    :background-color="readonly ? '' : '#f5f5f5'"
                    :readonly="true">
          <template v-slot:prepend-inner>
            <v-avatar :color="color"
                      v-if="value"
                      class="mt-2 ml-2"
                      size="15">
            </v-avatar>
            <div style="width:0;height:0;overflow:hidden;">{{value}}</div>
          </template>
        </v-combobox>
        <!-- <div v-show="color"
             @click="colorclick"
             :style="{ 'background-color': readonly ? 'white' : '#f5f5f5' }"
             class="colorbox d-flex align-center">
          <v-avatar :color="color"
                    v-if="color"
                    class="mr-2"
                    size="15"> </v-avatar>
          <div :style="{'font-size': '16px',color:color?'rgba(0,0,0,0.78)':'rgba(0,0,0,0.38)' }">
            {{ color?color:(readonly ? ' ' : label) }}
          </div>
        </div> -->
      </div>
    </template>
    <v-colorPicker @input="colorInput"
                   :value="color"> </v-colorPicker>
  </v-menu>
</template>

<script>
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  data () {
    return {
      color: ''
    }
  },
  watch: {
    value (v) {
      if (v) {
        this.color = v
      }
    }
  },
  model: {
    prop: 'value',
    event: 'colorChange',
  },
  created () { },
  mounted () {
    if (this.value) {
      this.color = this.value
    }
  },
  methods: {
    colorclick () {
      this.$refs.colorcombox.focus()
    },
    colorInput (v) {
      this.color = v
      this.$emit('colorChange', v)
    },
    clickClear () {
      this.$emit('colorChange', '')
    }
  },
  computed: {

  },
}
</script>

<style scoped>
.colorbox {
  padding-left: 8px;
  position: absolute;
  z-index: 4;
  top: 17px;
  width: 95%;
  height: 32px;
  line-height: 32px;
}
.box /deep/.v-input .v-label {
  top: -2px !important;
}
.csbox /deep/ .v-input .v-label {
  left: -25px !important;
}
.box /deep/ .v-text-field input {
  /* padding-left: 30px !important; */
}
</style>
